import React from 'react'
import classNames from 'classnames'

import { createStyles, withStyles, WithStyles, Theme } from '@material-ui/core/styles'

import Avatar from '@material-ui/core/Avatar'
import Typography from '@material-ui/core/Typography'
import Grid, { GridProps } from '@material-ui/core/Grid'

import defaultAvatar from 'assets/images/default_user_avatar.png'

import QuizModeButton from './components/QuizModeButton'

const styles = (theme: Theme) => {
  const clipPath = `
    polygon(
      0% 0%,
      100% 0%,
      100% calc(100% - ${theme.notchSize}),
      calc(100% - ${theme.notchSize}) 100%,
      ${theme.notchSize} 100%,
      0% calc(100% - ${theme.notchSize})
    )
  `
  return createStyles({
    root: {
      height: 40,
      paddingLeft: 10,
      paddingRight: 10,
      borderTopLeftRadius: 2,
      borderTopRightRadius: 2,
      backgroundColor: '#FFFFFF',
      clipPath,
      '-webkit-clip-path': clipPath,
    },
    team: {
      fontSize: 14,
      fontWeight: 500,
    },
    separator: {
      fontSize: 14,
      fontWeight: 500,
      paddingLeft: 10,
      paddingRight: 10,
      opacity: .3,
    },
    avatar: {
      width: 24,
      height: 24,
      borderWidth: 2,
      borderStyle: 'solid',
      borderColor: '#FFFFFF'
    },
    avatarValue: {
      height: 12,
      marginLeft: -3,
      paddingLeft: 6,
      paddingRight: 3,
      borderRadius: 3,
      backgroundColor: theme.palette.accent.main,
    },
    avatarValueText: {
      color: 'white',
      fontSize: 9,
      fontWeight: 700,
      lineHeight: 1.4,
    },
    alpha: {
      opacity: .3,
    },
  })
}

interface Props extends GridProps {
  onClickDisplayQuizButton?: () => void,
  separator: string,
  isClassicGame?: boolean,
  homeTeam: React.ReactNode,
  awayTeam: React.ReactNode,
  displayQuizButton?: boolean,
  avatar?: {
    url?: string,
    value: number,
  },
}

type InjectedProps = Props & WithStyles<typeof styles>

const GameCardHeader: React.SFC<InjectedProps> = ({
  avatar,
  classes,
  homeTeam,
  awayTeam,
  className,
  separator,
  isClassicGame,
  displayQuizButton,
  onClickDisplayQuizButton,
  ...props
}) => {
  return (
    <Grid
      className={classNames(className, classes.root)}
      direction="row"
      alignItems="center"
      wrap="nowrap"
      container
      {...props}
    >
      <Grid zeroMinWidth item>
        <Typography className={classes.team} variant="body1" noWrap>
          {homeTeam}
        </Typography>
      </Grid>
      <Grid item>
        <Typography className={classes.separator} variant="body1" noWrap>
          {separator}
        </Typography>
      </Grid>
      <Grid zeroMinWidth item>
        <Typography className={classNames(classes.team, { [classes.alpha]: isClassicGame })} variant="body1" noWrap>
          {awayTeam}
        </Typography>
      </Grid>

      {displayQuizButton && (
        <>
          <Grid item xs />
          <Grid item>
            <QuizModeButton
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()

                if (onClickDisplayQuizButton) {
                  onClickDisplayQuizButton()
                }
              }}
              onMouseDown={(e) => {
                e.preventDefault()
                e.stopPropagation()
              }}
            />
          </Grid>
        </>
      )}

      {!displayQuizButton && avatar && (
        <>
          <Grid item xs />
          <Grid item>
            <Avatar className={classes.avatar} src={avatar.url || defaultAvatar} />
          </Grid>
          <Grid item>
            <div className={classes.avatarValue}>
              <Typography className={classes.avatarValueText}>{avatar.value}</Typography>
            </div>
          </Grid>
        </>
      )}
    </Grid>
  )
}

export default withStyles(styles)(GameCardHeader)
